import useLanguage from '@op/hooks/useLanguage';
import useSaveFilter from '@op/hooks/useSaveFilter';
import { gameInfoType } from '@op/types/common';
import React, { useMemo, useState } from 'react';
import { Button, Form, Input, Modal } from 'tea-component';
import { AccountOption } from '../AccountList';
import AccountFormSelect from '../AccountFormSelect';

export default function SaveFilterModal({
  gameInfo,
  visible,
  defaultSelected,
  options,
  close: onClickClose,
}: {
  gameInfo: gameInfoType;
  visible: boolean;
  close: () => void;
  defaultSelected: string[];
  options: AccountOption[];
}) {
  const { formatMessage } = useLanguage();
  const [selectedAccounts, setSelectedAccounts] = useState(defaultSelected);
  const {
    verifyName,
    filterName,
    setFilterName,
    tipsMessage,
    saveFilter,
    setTipsMessage,
    loading: saveLoading,
  } = useSaveFilter({ gameInfo, businessType: 3 });

  function close() {
    setTipsMessage('');
    onClickClose();
  }

  function saveFilterClick() {
    saveFilter({ social_media_by_account: selectedAccounts }, () => {
      close();
    });
  }

  const disabled = useMemo(() => {
    if (!filterName.trim()) {
      return true;
    }

    if (selectedAccounts.length === 0) return true;
  }, [filterName, selectedAccounts]);

  return (
    <div className="dbo-save-filter-modal-box">
      <Modal
        size={'l'}
        visible={visible}
        caption={formatMessage('Save Filter Setting')}
        onClose={close}
        className="dbo-save-filter-modal"
      >
        <Modal.Body>
          <Form className="model-form">
            <Form.Item
              status={tipsMessage ? 'error' : undefined}
              label={formatMessage({ id: 'Filter Setting Name' })}
              showStatusIcon={false}
              message={tipsMessage}
              required
            >
              <Input
                placeholder={formatMessage({ id: 'Please enter a name' })}
                className="model-input"
                value={filterName}
                onChange={(value) => {
                  setFilterName(value);
                  verifyName(value);
                }}
              />
            </Form.Item>
            <Form.Item
              required
              label={formatMessage({ id: 'Filter Settings' })}
            >
              <AccountFormSelect
                options={options}
                onChange={(value) => setSelectedAccounts(value)}
                value={selectedAccounts}
              ></AccountFormSelect>
            </Form.Item>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="primary"
            onClick={saveFilterClick}
            disabled={disabled}
            loading={saveLoading}
          >
            {formatMessage('Confirm')}
          </Button>
          <Button type="weak" onClick={close}>
            {formatMessage('Cancel')}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
